import React, { useState, useRef, useEffect } from 'react';
import { Spin } from 'antd';

const LOAD_DELAY_MS = 150;

const LoadMoreOnScroll = ({ onLoadMore, rootMargin = '200px' }) => {
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    let timeoutId;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        setLoading(true);
        timeoutId = setTimeout(onLoadMore, LOAD_DELAY_MS);
      },
      { rootMargin }
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div ref={ref} style={{ display: 'flex', justifyContent: 'center', padding: '10px 0', width: '100%' }}>
      {loading && <Spin />}
    </div>
  );
};

export default LoadMoreOnScroll;
